import { ExternalLink } from "lucide-react";
import { AdSlot } from "@/components/AdSlot";
import { Section } from "@/components/Section";
import { RESOURCES, BASICS } from "@/data/content";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const ResourceGroups = ({ groups }) => (
  <div className="grid gap-5 md:grid-cols-2">
    {groups.map((g) => (
      <div key={g.group} data-testid={`resource-group-${slug(g.group)}`} className="rounded-xl border border-slate-800 bg-[#121722] p-5">
        <h3 className="font-display font-semibold text-slate-100 mb-3">{g.group}</h3>
        <ul className="divide-y divide-slate-800">
          {g.links.map((l) => (
            <li key={l.url}>
              <a href={l.url} target="_blank" rel="noopener noreferrer" data-testid={`resource-link-${slug(l.name)}`} className="group flex items-start justify-between gap-3 py-2.5">
                <span>
                  <span className="block text-sm font-medium text-slate-200 group-hover:text-sky-400 transition-colors">{l.name}</span>
                  <span className="block text-xs text-slate-500">{l.note}</span>
                </span>
                <ExternalLink className="h-3.5 w-3.5 mt-1 shrink-0 text-slate-500 group-hover:text-sky-400" />
              </a>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);

export default function Resources() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-8 space-y-12">
      <header className="space-y-3 max-w-3xl">
        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-sky-400">Resources</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">Useful Resources for Parents & Investors</h1>
        <p className="text-sm sm:text-base text-slate-400">Trusted external links and basic educational information. This is general information, not financial, legal or tax advice.</p>
      </header>
      <Section id="investing-basics" eyebrow="Basics" title="Investing Basics">
        <div className="grid gap-5 md:grid-cols-3">
          {BASICS.map((b) => (
            <div key={b.t} className="rounded-xl border border-slate-800 bg-[#181F2C] p-5">
              <h3 className="font-display font-semibold mb-2">{b.t}</h3>
              <p className="text-sm leading-relaxed text-slate-400">{b.d}</p>
            </div>
          ))}
        </div>
      </Section>
      <AdSlot id="resources-mid" variant="leaderboard" />
      <Section id="resource-links" eyebrow="Links" title="External Resources">
        <ResourceGroups groups={RESOURCES} />
      </Section>
    </div>
  );
}
